import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { post } from './client';
import type { User } from './model';

export const accountKeys = {
  all: ['account'] as const,
  current: ['account', 'current'] as const,
};

export const login = (data: { username: string; password: string }) =>
  post<string>('/admin/login-by-password', data);

export interface WeworkLoginSession {
  loginId: string;
  authorizeUrl: string;
  expiresIn: number;
}

export interface WeworkLoginStatus {
  status: 'waiting' | 'processing' | 'success' | 'failed';
  token?: string;
  message?: string;
}

export const createWeworkLogin = () =>
  post<WeworkLoginSession>('/admin/login-by-wework/start');

export const getWeworkLoginStatus = (loginId: string) =>
  post<WeworkLoginStatus>('/admin/login-by-wework/status', { loginId });

export const getCurrentAccount = () => post<User>('/admin/current');

export const useCurrentAccountQuery = () =>
  useQuery({
    queryKey: accountKeys.current,
    queryFn: getCurrentAccount,
  });

export const useLoginMutation = () => {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: login,
    onSuccess: () => qc.invalidateQueries({ queryKey: accountKeys.current }),
  });
};
